// extracted by mini-css-extract-plugin
module.exports = {"modal":"Detail_modal__1Tswt","contents":"Detail_contents__3leCw","header":"Detail_header__15BiZ","body":"Detail_body__3_hbj"};